export const baseUrl =
  window.location.origin !== "http://localhost:3000"
    ? window.location.origin + process.env.REACT_APP_API_URL
    : process.env.REACT_APP_DEV_URL;
